import React from 'react';
import classnames from 'classnames';
import { compact } from 'lodash';
import { Tag } from 'react-feather';

import StrapiButton from '../../StrapiLink/StrapiButton';
import { PromotionPanelFragment } from '../../../../graphql.schema';

import { useImageResize } from '../../../hooks/useImageResize';
import { fullImageUrl } from '../../../lib/helpers';

export const StrapiPromotionsPanelComponent = ({
  mainHeading,
  description,
  optional_link,
  promotions,
  secondHeading,
  secondDescription,
  image,
  secondaryLink,
}: PromotionPanelFragment) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./index.module.scss');
  if (isV2) {
    styles = require('./index-v2.module.scss');
  }

  const { imageStyle, imageUrl, imageWrapper } = useImageResize(image);

  if (isV2) {
    return (
      <div className={styles.promotionsPanelWrapper}>
        <div className={classnames(styles.info)}>
          <div className={styles.infoWrapper}>
            <h3 className="is-3 mb-4 title brand-a">{mainHeading}</h3>
            <p className={classnames(styles.text, 'is-text-2 black-2 mb-4')}>{description}</p>
            <ul className="mb-5">
              {compact(promotions).map(({ title }) => (
                <li className={classnames('mb-3', styles.promotionLink)} key={title}>
                  <Tag size={20} className={classnames(styles.tag, 'black-3 ml-1 has-text-weight-bold')} />
                  {title}
                </li>
              ))}
            </ul>
            {optional_link && <StrapiButton {...optional_link} icon="chevron" type="secondary" />}
            <div className={styles.secondaryInfo}>
              <h3 className="is-3 title brand-a">{secondHeading}</h3>
              <p className={classnames(styles.text, 'is-text-2 black-2 mb-4')}>{secondDescription}</p>
              {secondaryLink && <StrapiButton {...secondaryLink} icon="chevron" type="secondary" />}
            </div>
          </div>
        </div>

        <div ref={imageWrapper} className={classnames(styles.imageWrapper)}>
          <img
            alt={image?.alternativeText ?? image?.caption ?? ''}
            src={fullImageUrl(imageUrl)}
            loading="lazy"
            style={imageStyle}
            className={styles.image}
            width={image?.width}
            height={image?.height}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.promotionsPanelWrapper}>
      <div className="columns">
        <div className={classnames(styles.info, 'column is-4 is-offset-1')}>
          <h3 className="is-3 mb-3 title brand-a">{mainHeading}</h3>
          <p className={classnames(styles.text, 'is-text-2 black-2 mb-4')}>{description}</p>
          <ul>
            {compact(promotions).map(({ title }) => (
              <li className={classnames('mb-3', styles.promotionLink)} key={title}>
                <Tag size={20} className={classnames(styles.tag, 'black-3 ml-1 has-text-weight-bold')} />
                {title}
              </li>
            ))}
          </ul>
          {optional_link && <StrapiButton {...optional_link} type="primary" />}
          <div className={styles.secondaryInfo}>
            <h3 className="is-3 title brand-a">{secondHeading}</h3>
            <p className={classnames(styles.text, 'is-text-2 black-2 mb-4')}>{secondDescription}</p>
            {secondaryLink && <StrapiButton {...secondaryLink} type="secondary" />}
          </div>
        </div>
        <div ref={imageWrapper} className={classnames(styles.imageWrapper, 'column is-offset-1 is-6 is-hidden-mobile')}>
          <img
            alt={image?.alternativeText ?? image?.caption ?? ''}
            src={fullImageUrl(imageUrl)}
            loading="lazy"
            style={imageStyle}
            className={styles.image}
            width={image?.width}
            height={image?.height}
          />
        </div>
      </div>
    </div>
  );
};
